import { render, staticRenderFns } from "./PriceLpuBack.vue?vue&type=template&id=01896346&"
import script from "./PriceLpuBack.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceLpuBack.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01896346')) {
      api.createRecord('01896346', component.options)
    } else {
      api.reload('01896346', component.options)
    }
    module.hot.accept("./PriceLpuBack.vue?vue&type=template&id=01896346&", function () {
      api.rerender('01896346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceLpuBack.vue"
export default component.exports